import { Table } from '@mantine/core'
import { Category } from 'types/products'
import { GroupedShortageTableItem } from 'types/shortage'
import { getCategoryName, getUnitName } from 'utils'

type Props = {
  groupedShortage: GroupedShortageTableItem
  totalShortagesAmount: number
}

export default function GroupedShortageInfo({ groupedShortage, totalShortagesAmount }: Props) {
  return (
    <Table variant="vertical" withTableBorder>
      <Table.Tbody>
        <Table.Tr>
          <Table.Th>Symbol produktu</Table.Th>
          <Table.Td>{groupedShortage.product.symbol}</Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Th>Rodzaj produktu</Table.Th>
          <Table.Td>{getCategoryName(groupedShortage.category, { capitalize: true }).mianownik}</Table.Td>
        </Table.Tr>
        {groupedShortage.feature && (
          <Table.Tr>
            <Table.Th>Cecha</Table.Th>
            <Table.Td>{groupedShortage.feature}</Table.Td>
          </Table.Tr>
        )}
        <Table.Tr>
          <Table.Th>{getSizeLabel(groupedShortage.category)}</Table.Th>
          <Table.Td>{groupedShortage.size} cm</Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Th>Zapotrzebowanie</Table.Th>
          <Table.Td>
            {totalShortagesAmount} {getUnitName(groupedShortage.subRows[0].unit).short}
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Th>Ilość braków</Table.Th>
          <Table.Td>{groupedShortage.subRows.length}</Table.Td>
        </Table.Tr>
        {groupedShortage.manufacturer && (
          <Table.Tr>
            <Table.Th>Producent</Table.Th>
            <Table.Td>{groupedShortage.manufacturer.name}</Table.Td>
          </Table.Tr>
        )}
      </Table.Tbody>
    </Table>
  )
}

function getSizeLabel(category: Category) {
  switch (category) {
    case Category.FABRIC:
      return 'Szerokość'
    case Category.PREMADE:
      return 'Wymiar'
    default:
      return 'Rozmiar'
  }
}
